import dayjs from 'dayjs';

export type CalendarPosition = {
  calendarId: string;
  date: dayjs.Dayjs;
};

export enum NavigationDirection {
  Up = 'UP',
  Down = 'DOWN',
  Left = 'LEFT',
  Right = 'RIGHT'
}
